const Materiau = ({imageUrl, title, description}) => {

    return(
        <>
            <div className="col-6 col-md-3 mb-4">
                <label>
                    <input
                    type="radio"
                    name="materiau"
                    defaultValue="plaque-bac-acier"
                    className="materiau-radio"
                    />
                    <div className="materiau-wrapper">
                    <img
                        src={imageUrl}
                        alt="Plaque bac acier"
                        style={{ maxWidth: "100%" }}
                    />
                    <div className="rectangle px-4 py-1">
                        <p className="Card-title">{title}</p>
                        <p className="Card-sub-title" style={{ opacity: 1, zIndex: 2 }}>
                            {description}
                        </p>
                    </div>
                    </div>
                </label>
            </div>
        </>
    )

}

export default Materiau;